export default __webpack_public_path__ + "static/media/sponsor-9.68db1bff.svg";